module.exports = __webpack_public_path__ + "img/shopping_application_3-1.70772e7a.jpg";